import Button from "common/components/Button/Button"
import { withFormik } from "formik"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import {
  numeroDocumentoSelector,
  serieDocumentoSelector,
  setSerieAndNumero,
} from "../redux/slices/newDocumentoSlice"

const ABC = "abcdefghijklmnñopqrstuvwxyz"

// @ts-expect-error TS(2769): No overload matches this call.
export const SERIES_OPTIONS = ABC.split``.map((serie) => ({
  name: serie.toUpperCase(),
  value: serie.toUpperCase(),
}))

const TituloFactura = ({
  handleSubmit,
  values,
  onHide,
  isValid,
  setFieldValue,
  onChangeLastAvailableNumero,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const fetchAvailableNumero = async (serie: $TSMigrationFixMe) => {
    const data = await onChangeLastAvailableNumero?.(serie)
    setFieldValue("numero", data?.data)
  }
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='titulo'>
            {t("crear.facturaRec.modal.serieLabel")}
          </label>
          <Dropdown
            autoFocus
            id='serie'
            name='serie'
            optionLabel='name'
            options={SERIES_OPTIONS}
            value={values.serie}
            onChange={(e) => {
              setFieldValue("serie", e.value)
              fetchAvailableNumero(e.value)
            }}
            // @ts-expect-error TS(2769): No overload matches this call.
            autoComplete='off'
          />
        </div>
      </div>
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='titulo'>
            {t("crear.facturaRec.modal.numberLabel")}
          </label>
          <InputNumber
            autoFocus
            id='numero'
            name='numero'
            value={values.numero}
            min={1}
            useGrouping={false}
            onChange={(e) => setFieldValue("numero", e.value)}
            // @ts-expect-error TS(2769): No overload matches this call.
            autoComplete='off'
          />
        </div>
      </div>
      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>
          <Button
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
          >
            {t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const CreateWithFormik = withFormik({
  validationSchema: Yup.object().shape({
    numero: Yup.number().required(),
    serie: Yup.string().required(),
  }),
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'numero' does not exist on type '{}'.
  mapPropsToValues: ({ numero, serie }) => ({
    numero,
    serie,
  }),
  handleSubmit: (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'setSerieAndNumero' does not exist on typ...
    props.setSerieAndNumero(values)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(TituloFactura)

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  serie: serieDocumentoSelector(state),
  numero: numeroDocumentoSelector(state),
})

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setSerieAndNumero: (payload: $TSMigrationFixMe) =>
    dispatch(setSerieAndNumero(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
